import React from 'react';
import { connect } from 'react-redux';
import { DataSources } from '@leverege/ui-attributes';
import Groupings from "../Groupings.js";
import GroupingsModel from "./GroupingsModel.js";
import ValueRendererFactory from "./ValueRendererFactory.js";
/**
 * This will render the GeoLayers of a Grouping's Section's values
 */
class GroupingsRenderer extends React.Component {
  componentDidMount() {
    const {
      groupingObjRef,
      dispatch,
      groupingActions: delegate
    } = this.props;
    const item = DataSources.getData(groupingObjRef);
    if (item == null && delegate != null) {
      dispatch(delegate.get());
    }
  }
  componentDidUpdate(prev) {
    const {
      groupingObjRef,
      dispatch,
      groupingActions: delegate
    } = this.props;
    if (prev.groupingObjRef?.id !== groupingObjRef.id) {
      const item = DataSources.getData(groupingObjRef);
      if (item == null && delegate != null) {
        dispatch(delegate.get());
      }
    }
  }
  render() {
    const {
      model,
      groupingObjRef,
      order,
      sectionsState,
      groupings
    } = this.props;
    if (model.visible === false || groupings == null || sectionsState == null) {
      return null;
    }
    const rtn = [];
    const {
      id
    } = groupingObjRef;
    const opacity = this.getOpacity();
    groupings.sections?.forEach(section => {
      if (section.values == null || section.values.length === 0) {
        return;
      }
      const sLevel = Groupings.getValueData(groupings, section.id, sectionsState[section.id]);
      const before = `normal-${order}`;
      section.values.forEach(level => {
        const baseId = `${id}-${section.id}-${level.id}`;
        const selected = level === sLevel;
        if (Array.isArray(level.geoLayers)) {
          level.geoLayers.forEach((layer, index) => {
            const renderer = ValueRendererFactory.get(layer);
            if (renderer) {
              const arr = renderer({
                groupings,
                section,
                level,
                layer,
                index,
                opacity,
                model,
                selected,
                baseId,
                before
              });
              if (Array.isArray(arr) && arr.length > 0) {
                arr.forEach(e => rtn.push(e));
              } else if (arr) {
                rtn.push(arr);
              }
            }
          });
        }
      });
    });
    return rtn;
  }
  getOpacity() {
    const {
      model
    } = this.props;
    const opacity = model ? GroupingsModel.getOpacity(model) || 1 : 1;
    return opacity;
  }
}
export default connect((state, props) => {
  // Do some calculation/data retreival as necessary
  return {
    // selected : Selection.get( state, 'selected' ), 
    // rollover : Selection.get( state, 'rollover' ), 
    groupings: Groupings.getGrouping(state),
    sectionsState: Groupings.getSelectedSectionValues(state)
    // sectionsState : UI.get( state, 'itemSections' ) || {}
  };
})(GroupingsRenderer);